import { useEffect, useState } from 'react';

export const useFileUrl = ({ pdfBlob }: { pdfBlob: Blob | MediaSource }) => {
  const [fileUrl, setFileUrl] = useState<string>();

  useEffect(() => {
    if (pdfBlob) {
      const objectUrl = URL.createObjectURL(pdfBlob as Blob);
      setFileUrl(objectUrl);

      // Cleanup to avoid memory leaks
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [pdfBlob]);

  return { fileUrl };
};
